<template>
    <div>
      <c-search-box @enter="getList">
        <template slot="search">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-select
              codeGroupCd="OBLI_TYPE_CD"
              type="search"
              itemText="codeName"
              itemValue="code"
              name="obliTypeCd"
              label="구분"
              v-model="searchParam.obliTypeCd"
            ></c-select>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <!--사용여부-->
            <c-select
              :comboItems="useFlagItems"
              type="search"
              itemText="codeName"
              itemValue="code"
              name="useFlag"
              label="LBLUSEFLAG"
              v-model="searchParam.useFlag"
            ></c-select>
          </div>
        </template>
      </c-search-box>
      <c-table
        ref="grid"
        title="평가항목 목록"
        tableId="grid"
        :columns="grid.columns"
        :data="grid.data"
        selection="multiple"
        rowKey="saiSafetyHealthObliItemId"
        :editable="editable"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline>
            <!--추가-->
            <c-btn v-if="editable" label="LBLADD" :showLoading="true" icon="add" @btnClicked="addItem" />
            <c-btn v-if="editable" label="삭제" :showLoading="true" icon="remove" @btnClicked="removeItem" />
            <!--저장-->
            <c-btn
              v-show="editable && grid.data.length > 0"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="grid.data"
              mappingType="POST"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveItem"
              @btnCallback="saveCallback" />
            <!--검색-->
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </template>
      </c-table>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>
  </template>
  <script>
  import { uid } from 'quasar'
  import selectConfig from '@/js/selectConfig';
  import transactionConfig from '@/js/transactionConfig';
  export default {
    name: "internal-external-issues-item",
      data() {
      return {
        grid: {
          columns: [
            {
              required: true,
              setHeader: true,
              name: "obliTypeCd",
              field: "obliTypeCd",
              label: "구분",
              style: 'width:200px',
              align: "center",
              type: 'select',
              sortable: false,
              codeGroupCd: 'OBLI_TYPE_CD',
            },
            {
              required: true,
              name: "obliItemEvalCriteria",
              field: "obliItemEvalCriteria",
              label: "평가지표",
              align: "left",
              type: 'text',
              sortable: false,
            },
            {
              required: true,
              name: "obliItemConfirmTarget",
              field: "obliItemConfirmTarget",
              label: "확인대상",
              style: 'width:400px',
              align: "left",
              type: 'text',
              sortable: false,
            },
            {
              required: true,
              name: "distribution",
              field: "distribution",
              label: "배점",
              style: 'width:80px',
              align: "left",
              type: 'number',
              sortable: false,
            },
            {
              name: "deductedFlag",
              field: "deductedFlag",
              //사용여부
              label: "가점여부",
              align: "center",
              style: 'width:80px',
              type: 'check',
              sortable: false,
              true: 'Y',
              false: 'N'
            },
            {
              name: "useFlag",
              field: "useFlag",
              //사용여부
              label: "LBLUSEFLAG",
              align: "center",
              style: 'width:80px',
              type: 'check',
              sortable: false,
              true: 'Y',
              false: 'N'
            },
            {
              required: true,
              name: "sortOrder",
              field: "sortOrder",
              label: "번호",
              style: 'width:80px',
              align: "right",
              type: 'number',
              sortable: false,
            },
          ],
          data: [],
        },
        useFlagItems: [
          { code: 'Y', codeName: '사용' },
          { code: 'N', codeName: '미사용' },
        ],
        searchParam: {
          obliTypeCd: null,
          useFlag: 'Y',
        },
        editable: true,
        listUrl: '',
        saveUrl: '',
        updateUrl: '',
        popupOptions: {
          target: null,
          title: "",
          visible: false,
          top: "",
          param: {},
          closeCallback: null,
        },
        isSave: false,
      };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
      Object.assign(this.$data, this.$options.data());
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {},
    methods: {
      init() {
        this.editable = this.$route.meta.editable;
        this.listUrl = selectConfig.sai.obli.item.list.url;
        this.saveUrl = transactionConfig.sai.obli.item.save.url;
        this.deleteUrl = transactionConfig.sai.obli.item.delete.url;
        // url setting
        // code setting
        // list setting
        this.getList();
      },
      getList() {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      },
      addItem() {
        this.grid.data.push({
          issuesItemId: uid(),
          saiSafetyHealthObliItemId: uid(),  // 일련번호
          obliTypeCd: null,  // 구분
          obliItemEvalCriteria: '',  // 평가지표
          obliItemConfirmTarget: '',  // 확인대상
          distribution: '',  // 배점
          deductedFlag: 'N',  // 가점여부
          useFlag: 'Y',  // 사용여부
          sortOrder: (this.grid.data.length + 1),
          editFlag: 'C',
          regUserId: this.$store.getters.user.userId,
        })
      },
      /* eslint-disable no-unused-vars */ 
      saveItem() {
        if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',  
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        }
      },
      saveCallback() {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.getList();
      },
      removeItem() {
        let selectData = this.$refs['grid'].selected;
        if (!selectData || selectData.length === 0) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '선택된 항목이 없습니다.', // 선택된 항목이 없습니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          window.getApp.$emit('CONFIRM', {
          title: '확인',  
          message: '삭제하시겠습니까?', 
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              this.$_.forEach(selectData, _item => {
                this.grid.data = this.$_.reject(this.grid.data, { saiSafetyHealthObliItemId: _item.saiSafetyHealthObliItemId })
              })
              window.getApp.$emit('APP_REQUEST_SUCCESS');
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
        }
      },
    },
  };
  </script>
  